import React from 'react';
import AuthPageContainer from './container';
import LoginHeader from 'components/login/loginHeader';
import LoginForm from 'components/login/login';
import SignupButton from './SignupButton';
import SignupFooter from './SignupFooter';

export default function LoginPage() {
  return (
    <AuthPageContainer renderNav={SignupButton} renderFooter={SignupFooter}>
      <LoginHeader />
      <LoginForm onSuccess={() => (window.location = '/')} />
    </AuthPageContainer>
  );
}
